import React from 'react'
import Layout from '../layouts/index.js'
import Contact from '../components/contact/contact.js'
import ImageSlider from '../components/hero/index'

function importAll(r) {
  return r.keys().map(r)
}

const images = importAll(
  require.context(
    '../images/street-food-page',
    false,
    /\.(png|jpe?g)$/ // png, jpg, jpeg
  )
)

class LunchTruckPage extends React.Component {
  render() {
    return (
      <Layout head={{ title: 'Street Food Trucks, Trailers & Food Pavilions' }}>
        <section id="title">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h1 className="heading-title">
                  Street Food Trucks, Trailers & Food Pavilions
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section
          id="street-food-trucks-trailers-food-pavilions"
          className="text-center"
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <h1
                  className="section-title"
                  style={{ maxWidth: '800px', margin: '0 auto 40px' }}
                >
                  Street Food Advertising
                </h1>
                <div
                  className="mb-5 "
                  style={{ maxWidth: '800px', margin: '0 auto' }}
                >
                  <p className="section-p">
                    All street food trucks, trailers and food pavilions have
                    multiple touch points.
                  </p>
                  <p className="section-p">
                    Media rate will include (1) 60 x 30 Billboard placed in a
                    visible location on the Truck/Trailer or Pavilion.
                  </p>
                  <p className="section-p">
                    If the truck is fully wrapped with operator's graphics (2)
                    18 x 24 or 24 x 18 billboards will be used in place of the
                    60 x 30.
                  </p>
                </div>
                <div className="container" style={{ maxWidth: '1800px' }}>
                  <div className="carousel-container">
                    <ImageSlider images={images} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </Layout>
    )
  }
}
export default LunchTruckPage
